import * as React from 'react';
import Svg, {SvgProps, Circle} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={140}
    height={88}
    viewBox={'0 0 140 88'}
    {...props}
    fill="none"
    stroke="none">
    <Circle cx={18} cy={40} r={11} fill={props.fill || '#3F62A1'} />
    <Circle cx={77.391} cy={32.391} r={8.391} fill={props.fill || '#3F62A1'} />
    <Circle cx={60.5} cy={76.5} r={11.5} fill={props.fill || '#3F62A1'} />
    <Circle cx={45.196} cy={18.195} r={4.196} fill={props.fill || '#3F62A1'} />
    <Circle cx={22.471} cy={2.098} r={2.098} fill={props.fill || '#3F62A1'} />
    <Circle
      cx={31.523}
      cy={142.523}
      r={76.145}
      fill={props.fill || '#3F62A1'}
      transform="rotate(-48.151 31.523 142.523)"
    />
  </Svg>
);
export default SvgComponent;
